import { EntitySetName, EntityTypeName, PrLongTermCaregivingEventEntity } from "@odata/GeneratedEntityTypes";
import { PrSocialEventTypeCode } from "@odata/GeneratedEnums";
import { getEnumNameSpaceName } from "@odata/GeneratedEnums.utils";
import { setDefByEntityType } from "@pages/getDefByEntityType";
import { IDefinition, IGetDefinition } from "@pages/PageUtils";
import LongtermCaregivingAllowanceFormView
    from "@pages/payroll/socialEvents/eventTypes/LongtermCaregivingAllowanceFormView";
import { cloneDeep } from "lodash";

import { IAppContext } from "../../../../contexts/appContext/AppContext.types";
import {
    addCaregivingMonthDetailDefinitions,
    addCaregivingReceiverDefinitions,
    addReadOnlyBasedOnDateEventEnd,
    addRequiredActionSummaryDef,
    addSubmissionTableDefinitions,
    addSwitchGroupDefinitions,
    getDefinitions as commonDef,
    getSocialEventsFormDef
} from "../SocialEventsDef";

export const getDefinitions: IGetDefinition = (context: IAppContext): IDefinition => {
    const d = cloneDeep(getSocialEventsFormDef(LongtermCaregivingAllowanceFormView, PrSocialEventTypeCode.LongtermCaregivingAllowance, context));

    addRequiredActionSummaryDef(d);
    addReadOnlyBasedOnDateEventEnd(d);

    addCaregivingReceiverDefinitions(d, true);
    addCaregivingMonthDetailDefinitions(d);

    // add CareEmployeeDeclarations group to definition, including fields
    const yesNoFields = [
        PrLongTermCaregivingEventEntity.IsSameHousehold,
        PrLongTermCaregivingEventEntity.IsSharedCaregiving,
        PrLongTermCaregivingEventEntity.IsSomeoneElseReceivingAllowance,
        PrLongTermCaregivingEventEntity.IsAllowanceReceiverUnfit,
    ];
    addSwitchGroupDefinitions(d, yesNoFields);

    // Table tabs on the end of the form
    addSubmissionTableDefinitions(d);

    return {
        ...d,
        entitySet: EntitySetName.PrLongTermCaregivingEvents
    };
};

getDefinitions.translationFiles = [
    ...commonDef.translationFiles,
    getEnumNameSpaceName(EntityTypeName.PrSocialEventMonthDetailType)
];
setDefByEntityType(EntityTypeName.PrLongTermCaregivingEvent, getDefinitions);